import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class MyCompanyAccountService {

  constructor(private httpClient: HttpClient, private occEndPointsService: OccEndpointsService) { }

  getManageUsers(searchText = "", currentPage = 0, sortType = "") {
    return this.httpClient.get(this.occEndPointsService.buildUrl(`mycompnay/getmycompanyuser?searchTerm=${searchText}&page=${currentPage}&sortCode=${sortType}&&pageSize=9`));
  }

  setDisable(userID) {
    return this.httpClient.post(this.occEndPointsService.buildUrl(`/mycompnay/disable?user=${encodeURIComponent(userID)}`), {});
  }

  setEnable(userID) {
    return this.httpClient.post(this.occEndPointsService.buildUrl(`mycompnay/enable?user=${encodeURIComponent(userID)}`), {})
  }

  getUserDetails(userId) {
    return this.httpClient.get(this.occEndPointsService.buildUrl(`mycompnay/edit?user=${encodeURIComponent(userId)}`));
  }
  retriggerEmail(userId) {
    return this.httpClient.post(this.occEndPointsService.buildUrl(`mycompnay/retrigger-email?user=${encodeURIComponent(userId)}`), {})
  }

  deleteUser(userId) {
    return this.httpClient.post(this.occEndPointsService.buildUrl(`mycompnay/close-account?user=${encodeURIComponent(userId)}`), {})
  }

  createUserGet() {
    return this.httpClient.get(this.occEndPointsService.buildUrl(`mycompnay/create`));
  }

  updateUser(payload) {
    return this.httpClient.post(this.occEndPointsService.buildUrl(`mycompnay/edit?user=${encodeURIComponent(payload.uid)}`), payload)
  }

  getCreateUserDetails() {
    return this.httpClient.get(this.occEndPointsService.buildUrl(`mycompnay/create`));
  }

  getRegistrationRequests(currentPage = 0, sortType = "") {
    return this.httpClient.get(this.occEndPointsService.buildUrl(`mycompnay/registration-request?page=${currentPage}&sortCode=${sortType}`));
  }

  saveUser(payload) {
    return this.httpClient.post(this.occEndPointsService.buildUrl(`mycompnay/create?`), payload)
  }

  declineUser(userId) {
    return this.httpClient.post(this.occEndPointsService.buildUrl(`mycompnay/reject?user=${encodeURIComponent(userId)}`), {})
  }

  approveUser(userId) {
    return this.httpClient.post(this.occEndPointsService.buildUrl(`mycompnay/approve?user=${encodeURIComponent(userId)}`), {})
  }

  updateRegistrationUser(payload) {
    return this.httpClient.post(this.occEndPointsService.buildUrl(`mycompnay/registration-detail?user=${encodeURIComponent(payload.uid)}`), payload)
  }
}
